import React, { Component } from "react";
import {
    Label,
    Row,
    Col,
    Input,
    Button
} from "reactstrap";
import Geosuggest from "react-geosuggest";

import Registry from "../../../Utils/Registry";
import CreateOrderTimeSlot from "../TimeSlot";
import CreateOrderCalendar from "../Calendar";
import TYSelect from "../../TYSelect";

import Business from "../../../models/business";
import {NotificationManager} from "react-notifications";


class CreateOrderFormInformation extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");
        this.calendarComposent = null;

        this.suggestChosen = this.suggestChosen.bind(this);
        this.slotChosen = this.slotChosen.bind(this);
        this.togglePrivateDeliveryCheckbox = this.togglePrivateDeliveryCheckbox.bind(this);
        this.toggleGeoSuggest = this.toggleGeoSuggest.bind(this);
        this.renderAddress = this.renderAddress.bind(this);
        this.addressChoosen = this.addressChoosen.bind(this);
        this.loadAddresses = this.loadAddresses.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.updatedComment = this.updatedComment.bind(this);

        if(this.props.state)
            this.state = this.props.state;
        else{
            this.state = {
                privateDeliveryCheckbox: this.props.address_checked,
                show_geosuggest: false,
                addresses: [],
                meta_data: [],
                address: this.props.address,
                selected_address: null,
                slot: this.props.slot,
                comment: this.props.comment,
                calendar_state: false,
                valid_address: false,
                slot_state: false
            };
        }
    }

    componentDidMount(){
        this.loadAddresses();
    }

    togglePrivateDeliveryCheckbox(){
        this.setState({privateDeliveryCheckbox: !this.state.privateDeliveryCheckbox});
    }
    
    addMetaDataField = () => {
        let m = this.state.meta_data;
        m.push({label: '', value: ''});
        this.setState({meta_data: m});
    };

    loadAddresses(){
        Business.getAddresses(results => {
            this.setState({
                addresses: results
            });
        })
    }

    suggestChosen(suggest){
        this.setState({address: suggest.description, slot: false}, () => this.checkAddress(suggest.description));
    }

    slotChosen(date, state){
        this.setState({
            slot: {
                ...this.state.slot,
                date
            },
            calendar_state: state
        }, () => {
            const { slot } = this.state;
            if(slot && slot.min && slot.max && slot.date)
                this.props.onSlotChosen(slot);
        });
    }

    onTimeSlotChosen = (min, max, state) => {
        this.setState({
            slot: {
                ...this.state.slot,
                min,
                max
            },
            slot_state: state
        }, () => {
            const { slot } = this.state;
            if(slot && slot.min && slot.max && slot.date)
                this.props.onSlotChosen(slot);
        });
    }

    toggleGeoSuggest(){
        this.setState({show_geosuggest: !this.state.show_geosuggest});
    }

    updatedComment(e){
        this.setState({comment: e.target.value});
    }

    renderAddress(address){
        return address.getLabel();
    }

    addressChoosen(address){
        this.setState({address: address.location, selected_address: address}, () => this.checkAddress(address.location) );
    }

    validateStep(){
        if(this.state.privateDeliveryCheckbox && this.state.slot)
            this.props.onValidateStep(this.state.address, this.state.slot, this.state.comment, this.state);
    }

    checkAddress = (address) => {
        this.api.get("/orders/checkZone?address=" + address + "&is_business=1")
            .then(() => {
                this.setState({address: address, valid_address: true}, () => {
                    if(this.calendarComposent)
                        this.calendarComposent.toggleCalendar();
                    this.props.displayGasPrices(true);
                    this.props.onAddressSelected(address);
                    this.validateStep();
                });
            })
            .catch((e) => {
                this.setState({address: "", valid_address: false}, () => {
                    this.props.displayGasPrices(false);
                });
                NotificationManager.error("Cette adresse n'est pas dans la zone de livraison");
            })
    };

    updateMetaData = (i, e, value_type) => {
        let m = this.state.meta_data;
        if(m[i])
            m[i][value_type] = e.target.value;
        this.setState({meta_data: m});
    };

    render(){
        return (
            <div>
                <h2 className="ty-subtitle">
                    Renseigner vos informations de livraison
                </h2>

                <div className="ty-block">
                    <Row>
                        <Col md="12">
                            <Label>Adresse de livraison *</Label>
                            {
                                !this.state.show_geosuggest ?
                                    <TYSelect
                                        items={this.state.addresses}
                                        selected={this.state.selected_address}
                                        isSelected={(selected, item) => {return selected && selected.id === item.id}}
                                        itemClicked={this.addressChoosen}
                                        renderItem={this.renderAddress}
                                        onFooterClicked={this.toggleGeoSuggest}
                                        footer="Autre"
                                    />
                                    :
                                    <Geosuggest
                                        country="fr"
                                        onSuggestSelect={this.suggestChosen}
                                        placeholder="Renseignez votre adresse de livraison ..."
                                        inputClassName="order-big-input"
                                        initialValue={this.state.address ? this.state.address : ""}
                                    />
                            }
                        </Col>
                    </Row>
                    <Row className="marg-t-10">
                        <Col md="12">
                            <Label>Date *</Label>
                            <CreateOrderCalendar
                                ref={ref => {this.calendarComposent = ref;}}
                                location={this.state.address}
                                onDateChosen={this.slotChosen}
                                state={this.state.calendar_state}
                            />
                        </Col>
                    </Row>
                    <Row className="marg-t-10">
                        <Col md="12">
                            <Label>Créneaux souhaités *</Label>
                            <CreateOrderTimeSlot
                                ref={ref => {this.timeSlotComposent = ref;}}
                                onSlotSelected={this.onTimeSlotChosen}
                                state={this.state.slot_state}
                            />
                        </Col>
                    </Row>
                    <Row className="marg-t-15">
                        <Col md="12">
                            <Label style={{display: "flex", justifyContent: "space-between"}}>
                                Informations utiles &agrave; votre livraison
                                <i className="icon icon-plus pointer pink" onClick={this.addMetaDataField}></i>
                            </Label>
                            <Input
                                type="textarea"
                                rows="5"
                                value={this.state.comment}
                                onChange={this.updatedComment}
                                placeholder="Exemple : Clés à récupérer à l'accueil, Contact sur place : Mr Dupont 0612345678, ..."
                            />
                        </Col>
                    </Row>
                    {
                        this.state.meta_data.length ? 
                            <Row className="marg-t-20">
                                <Col><Label>Titre</Label></Col>
                                <Col><Label>Valeur</Label></Col>
                            </Row>
                            : ""
                    }
                    {
                        this.state.meta_data.map((m, i) => {
                            return <Row key={"meta-data-" + i} className="marg-b-10">
                                <Col><Input type="text" value={m.label} placeholder="Code, Parking, ..." onChange={txt => { this.updateMetaData(i, txt, 'label')}} /></Col>
                                <Col><Input type="text" value={m.value} placeholder="19B58, A3, ..." onChange={txt => { this.updateMetaData(i, txt, 'value')}} /></Col>
                            </Row>
                        })
                    }
                    <Row>
                        <Col>
                            <div className="marg-t-10">
                                <input className="ty-checkbox" type="checkbox" id="privateDelivery" onChange={this.togglePrivateDeliveryCheckbox} checked={this.state.privateDeliveryCheckbox} />
                                <label htmlFor="privateDelivery" className="blue_dark no-bold marg-t-5 f-12">
                                    La livraison ne peut s'effectuer que sur un espace priv&eacute; avec
                                    votre pr&eacute;sence ou bien en laissant la trappe &agrave; essence ouverte.
                                </label>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="center marg-t-20">
                    <Button
                        className="text-uppercase"
                        color="primary"
                        disabled={!this.state.slot.date || this.state.slot.min === undefined || this.state.slot.max === undefined || !this.state.privateDeliveryCheckbox || !this.state.valid_address}
                        onClick={this.validateStep}
                    >
                        Valider
                    </Button>
                </div>
            </div>
        );
    }
}

CreateOrderFormInformation.defaultProps = {
    onSlotChosen: slot => {},
    onValidateStep: (location, slot, comment) => {},
    comment: "",
    address_checked: false,
    slot: {
        date: false,
        min: undefined, 
        max: undefined
    },
    address: false,
    state: null,
    onAddressSelected: () => {},
    displayGasPrices: () => {}
};

export default CreateOrderFormInformation;



// WEBPACK FOOTER //
// ./src/components/CreateOrder/Form/Information.js